import axios from 'axios';
import AuthService from './auth'
import PlanoService from './planos';
import AssinaturaService from './assinatura';
import UsuarioService from './usuario';
import LoginService from './login';
import ProfissionalClinicaService from './profissional_clinica';
import JogosEducativosService from './jogos_educativos';
import LojasService from './lojas';
import EventosService from './eventos';
import PedidosCartaoService from './pedidos_cartao';
import ClinicaService from './clinica';
import GruposApoioService from './gruposApoio';
import ContatoService from './contato';
import ProfissionaisService from './profissionais';
import LivrosService from './livros';
import EspecialidadeService from './especialidade';
import CategoriaLojaService from './categoria_lojas';
import CursoService from './curso';
import EstadoService from './estado';
import RedesSociaisService from './redes_sociais';
import PaginasService from './paginas';
import ImagensClinicasService from './imagem_clinica';
import CorretorService from './corretor';
import ValorService from './valor';
import PagamentoService from './pagamento';
import CartaoSerivce from './cartao';


const API_ENVS = {
  production: '',
  development: '',
  local: 'https://backendautfriends.centrion.com.br/api/' //'http://192.168.3.12:8888/api/' 
}
const httpClient = axios.create({
  baseURL: API_ENVS.local
})
export default {
  devServer: {
    proxy: 'http://192.168.3.12:8888/api/'
  },
  auth: AuthService(httpClient),//OK
  categoria_loja: CategoriaLojaService(httpClient),//OK
  contato: ContatoService(httpClient), //OK
  clinica: ClinicaService(httpClient), //ok
  curso: CursoService(httpClient), //ok
  especialidade: EspecialidadeService(httpClient), //ok
  estado: EstadoService(httpClient), //ok
  grupos_apoio: GruposApoioService(httpClient),//OK
  jogos_educativos: JogosEducativosService(httpClient),//OK
  livros: LivrosService(httpClient), //OK
  login: LoginService(httpClient),//OK
  lojas: LojasService(httpClient), //OK
  eventos: EventosService(httpClient), //OK
  pedidos_cartao: PedidosCartaoService(httpClient), //OK
  assinaturas: AssinaturaService(httpClient), //OK
  plano: PlanoService(httpClient), //OK
  profissionais: ProfissionaisService(httpClient), //OK
  profissional_clinica: ProfissionalClinicaService(httpClient),
  usuario: UsuarioService(httpClient),//OK
  redes_sociais: RedesSociaisService(httpClient),//OK
  paginas: PaginasService(httpClient),//OK
  imagem_clinica: ImagensClinicasService(httpClient),
  corretor: CorretorService(httpClient),
  valor: ValorService(httpClient),
  pagamento: PagamentoService(httpClient),
  cartao: CartaoSerivce(httpClient)
}